import * as Yup from 'yup';
import { StepRoleForm } from './step-role-types';

export const stepRoleSchema = () =>
  Yup.object<StepRoleForm>().shape({
    authorRole: Yup.mixed().nullable().required('Povinné pole'),
  });
